import fastRewind from '../../../../../../assets/icons/fastRewind.svg';
import cls from './FastRewindButton.module.scss';
interface FastForwardProps {
    onRewind: () => void;
}

const FastRewindButton = ({onRewind}: FastForwardProps) => (
    <button
        className={cls.button}
        onClick={onRewind}
    >
        {<img src={fastRewind} alt="fastRewind"/>}
    </button>
);
export default FastRewindButton;